import ClassNames from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Animated loading bar that can be added to the top of a container to show a loading state.
 * The loader is styled with position `absolute`, so does not affect the size of its parent container.
 */
class Loader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: true,
    };

    this.displayTimeout = null;
  }

  componentDidMount() {
    this.displayLoader();
  }

  componentDidUpdate(prevProps) {
    const { isLoading } = this.props;

    if (!prevProps.isLoading && isLoading) {
      this.restartLoader();
    }
  }

  componentWillUnmount() {
    this.clearTimeouts();
  }

  displayLoader = () => {
    const { isLoading } = this.props;

    if (isLoading) {
      this.displayTimeout = setTimeout(this.displayLoader, 1500);
    } else {
      this.setState({ active: false });
      this.clearTimeouts();
    }
  };

  restartLoader = () => {
    this.setState({ active: true });
    this.displayLoader();
  };

  clearTimeouts = () => {
    if (this.displayTimeout) {
      this.displayTimeout = clearTimeout(this.displayTimeout);
    }
  };

  render() {
    const { active } = this.state;
    const { classes } = this.props;

    return (
      <div
        className={ClassNames('Loader', classes, {
          'Loader--active': active,
        })}
      />
    );
  }
}

Loader.propTypes = {
  /**
   * A space-separated list of class names to apply to the loader `div`
   */
  classes: PropTypes.string,
  /**
   * Set to `true` to show loading animation; set to `false` and loader will not be shown
   */
  isLoading: PropTypes.bool,
};

Loader.defaultProps = {
  classes: null,
  isLoading: true,
};

/**
 * @type {React.ComponentType<any>}
 */
export default Loader;
